import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';

const Gallery = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 via-white to-cyan-50">
      <Helmet>
        <title>Roofing Gallery - Before & After Projects | OpenbooQ</title>
        <meta name="description" content="Browse our roofing gallery to see stunning before-and-after transformations. Get inspired by OpenbooQ's high-quality full roof replacements." />
      </Helmet>
      <Header />
      
      {/* Coming Soon Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-2xl mx-auto text-center">
          {/* Icon/Visual Element */}
          <div className="mb-8 flex justify-center">
            <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full flex items-center justify-center shadow-lg">
              <svg 
                className="w-12 h-12 text-white" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
                />
              </svg>
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
            Coming Soon
          </h1>
          
          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-600 mb-8">
            Our Project Gallery is Under Construction
          </p>
          
          {/* Description */}
          <p className="text-lg text-gray-500 mb-12 max-w-xl mx-auto leading-relaxed">
            We're curating an inspiring collection of completed roofing projects to showcase our craftsmanship and help you visualize your dream roof. Check back soon!
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/instant-estimate">
              <Button 
                size="lg"
                className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white px-8 py-3 rounded-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
              >
                Get Your Free Roof Price
              </Button>
            </Link>
            
            <Link to="/">
              <Button 
                size="lg"
                variant="outline"
                className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50 px-8 py-3 rounded-lg font-semibold transition-all duration-300"
              >
                Return Home
              </Button>
            </Link>
          </div>

          {/* Additional Info */}
          <div className="mt-16 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              In the meantime, explore our{' '}
              <Link to="/shingles" className="text-blue-600 hover:text-blue-700 font-medium underline">
                shingle options
              </Link>
              {' '}or{' '}
              <Link to="/reviews" className="text-blue-600 hover:text-blue-700 font-medium underline">
                read customer reviews
              </Link>
            </p>
          </div>

          {/* SEO Body Copy */}
          <div className="mt-16 pt-10 border-t border-gray-100 text-left max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Roofing Before & After Transformations</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Our project gallery will showcase real roof replacement transformations completed by OpenbooQ's certified installer network across the country. From worn-out asphalt shingles to stunning new architectural roofs, each project demonstrates the quality craftsmanship and premium materials that define the OpenbooQ standard.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              Choosing the right shingle color and style is one of the most important decisions in a roof replacement project. Our gallery will feature completed homes with GAF Timberline HDZ, Owens Corning Duration, Atlas Pinnacle Pristine, and TAMKO Titan XT shingles — giving you a real-world view of how each product looks on actual homes.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Whether you're drawn to classic charcoal, warm weathered wood tones, or bold designer colors, seeing finished projects helps you make a confident choice. In the meantime, browse our <Link to="/shingles" className="text-blue-600 hover:underline font-medium">shingle catalog</Link> to explore colors and styles, or <Link to="/instant-estimate" className="text-blue-600 hover:underline font-medium">get your roof price</Link> to start planning your new roof today.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Gallery;